export class ConfirmarRespuestaModel {
	type: ConfirmarRespuestaType;
	message: string;
	imagen: string;
	tipoConfirmacionModalType: TipoConfirmacionModalType;
	buttonTextAlert: string;
}

export enum ConfirmarRespuestaType {
	Atencion = '¡Atención!',
	Enviado = '¡Enviado!',
  Importante = 'Importante'
}

export enum TipoConfirmacionModalType {
	Confirmacion, Alerta
}

